class RegulationsModel {
    public turboAllowed: boolean = false;
    public skipAllowed: boolean = true;
    public lossLimitRequired: boolean = true;
    public unlimitedAutoplayAllowed: boolean = false;

    public isHoldToSpinAllowed() {
        return this.turboAllowed && this.skipAllowed;
    }
}

export default new RegulationsModel();
